import React from 'react';
import MainContent from './components/MainContent';
import './styles/FreeBoard.css';
import './styles/MarkdownTable.css';

const App = () => {
  return (
    <MainContent />
  );
};

export default App; 